import React from 'react';
import Typography from '@material-ui/core/Typography';

const ReportsPage = () => {
  return <Typography variant="h5">Reports</Typography>;
};

export default ReportsPage;
